"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getENV = exports.getUA = void 0;

var sdk_1 = require("./sdk"),
    sdk_2 = require("./sdk");

Object.defineProperty(exports, "ENV_ENUM", {
  enumerable: !0,
  get: function get() {
    return sdk_2.ENV_ENUM;
  }
}), Object.defineProperty(exports, "APP_TYPE", {
  enumerable: !0,
  get: function get() {
    return sdk_2.APP_TYPE;
  }
}), Object.defineProperty(exports, "ENV_ENUM_SUB", {
  enumerable: !0,
  get: function get() {
    return sdk_2.ENV_ENUM_SUB;
  }
});

var dingtalk_javascript_env_1 = require("./packages/dingtalk-javascript-env"),
    getTopBridge = function getTopBridge() {
  try {
    if ("undefined" != typeof window && void 0 !== window.top) {
      return window.top.__dingtalk_jsapi_top_platfrom_config__;
    }
  } catch (e) {
    return;
  }
},
    EDdWeexEnv;

!function (e) {
  e.singlePage = "singlePage", e.miniApp = "miniApp", e.miniWidget = "miniWidget";
}(EDdWeexEnv || (EDdWeexEnv = {})), exports.getUA = function () {
  var e = "";

  try {
    "undefined" != typeof navigator && (e = navigator && (navigator.userAgent || navigator.swuserAgent) || "");
  } catch (t) {
    e = "";
  }

  return e;
}, exports.getENV = function () {
  var e = exports.getUA(),
      t = /iPhone|iPad|iPod|iOS/i.test(e),
      i = /Android/i.test(e),
      n = (/Nebula/i.test(e), /DingTalk/i.test(e)),
      a = /dd-web/i.test(e),
      r = "object" == typeof nuva,
      d = "object" == typeof dd && "function" == typeof dd.dtBridge,
      _ = d && t || r && t,
      s = n || dingtalk_javascript_env_1.default.isDingTalk,
      o = t && s || dingtalk_javascript_env_1.default.isWeexiOS || _,
      E = i && s || dingtalk_javascript_env_1.default.isWeexAndroid,
      g = d,
      p = a,
      l = sdk_1.APP_TYPE.WEB;

  if (p) l = sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP;else if (g) l = sdk_1.APP_TYPE.MINI_APP;else if (dingtalk_javascript_env_1.default.isWeexiOS || dingtalk_javascript_env_1.default.isWeexAndroid) try {
    var f = weex.config.ddWeexEnv;
    l = f === EDdWeexEnv.miniWidget ? sdk_1.APP_TYPE.WEEX_WIDGET : sdk_1.APP_TYPE.WEEX;
  } catch (e) {
    l = sdk_1.APP_TYPE.WEEX;
  }
  var u,
      v = "*",
      c = e.match(/AliApp\(\w+\/([a-zA-Z0-9.-]+)\)/);
  null === c && (c = e.match(/DingTalk\/([a-zA-Z0-9.-]+)/));
  var P;
  c && c[1] && (P = c[1]);
  var k = "";
  if ("undefined" != typeof name && (k = name), k) try {
    var N = JSON.parse(k);
    N.hostVersion && (P = N.hostVersion), v = N.language || navigator.language || "*", u = N.containerId;
  } catch (e) {}
  var A = !!u;
  A && !P && (c = e.match(/DingTalk\(([a-zA-Z0-9\.-]+)\)/)) && c[1] && (P = c[1]);
  var x,
      m = sdk_1.ENV_ENUM_SUB.noSub;
  if (o) x = sdk_1.ENV_ENUM.ios;else if (E) x = sdk_1.ENV_ENUM.android;else if (A) {
    var U = e.indexOf("Macintosh; Intel Mac OS") > -1;
    m = U ? sdk_1.ENV_ENUM_SUB.mac : sdk_1.ENV_ENUM_SUB.win, x = sdk_1.ENV_ENUM.pc;
  } else {
    var W = getTopBridge();
    x = W && W.platform ? W.platform : sdk_1.ENV_ENUM.notInDingTalk;
  }
  return {
    platform: x,
    platformSub: m,
    version: P,
    appType: l,
    language: v
  };
};